import { ReactComponent as DroneIcon } from "../../assets/icons/drone.svg";

const DroneIconButton = ({
  label,
  color = "#171954",
  width = "35",
  height = "35",
}) => {
  return (
    <button
      aria-label={label}
      style={{
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
        margin: 0,
        cursor: "pointer",
        color,
      }}
    >
      <DroneIcon width={width} height={height} data-testid="drone-icon" />
    </button>
  );
};

export default DroneIconButton;
